import React from 'react'

const skills = [
  { name: 'JavaScript (ES6+)', level: 90 },
  { name: 'React.js', level: 85 },
  { name: 'Node.js', level: 85 },
  { name: 'Express.js', level: 80 },
  { name: 'MongoDB & Mongoose', level: 75 },
  { name: 'REST API Development', level: 85 },
  { name: 'Python (Automation & Data Processing)', level: 75 },
  { name: 'Git & Version Control', level: 80 },
]

const Skills = () => {
  return (
    <section id="skills" className="bg-backgroundDark py-12 sm:py-16 md:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-4xl font-bold mb-4 text-textPrimary">
            Technical Skills
          </h2>
          <div className="w-16 sm:w-20 h-1 bg-primary mx-auto mb-4 sm:mb-6"></div>
          <p className="font-body text-base sm:text-lg text-textSecondary max-w-2xl mx-auto px-4">
            Technologies and tools I regularly use while building full-stack applications and automation systems.
          </p>
        </div>
        
        {/* Skills Grid - Responsive */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
          {skills.map((skill, idx) => (
            <div key={idx} className="bg-accent p-4 sm:p-6 rounded-lg hover:bg-accent/80 transition-all duration-300">
              <div className="flex justify-between items-center mb-3">
                <span className="font-heading text-base sm:text-lg font-semibold text-textPrimary">
                  {skill.name}
                </span>
                <span className="font-mono text-primary font-bold text-sm sm:text-base">
                  Comfort: {skill.level}%
                </span>
              </div>
              <div className="w-full bg-secondary/20 rounded-full h-2 sm:h-3 overflow-hidden">
                <div
                  className="bg-primary-gradient h-2 sm:h-3 rounded-full transition-all duration-1000 ease-out"
                  style={{ width: `${skill.level}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>

        {/* Always Learning Section - Mobile Optimized */}
        <div className="mt-12 sm:mt-14 md:mt-16 text-center">
          <div className="bg-accent p-6 sm:p-8 rounded-lg border border-primary/20">
            <h3 className="font-heading text-xl sm:text-2xl font-bold text-textPrimary mb-3 sm:mb-4">
              Current Focus
            </h3>
            <p className="font-body text-textSecondary text-base sm:text-lg leading-relaxed">
              Currently strengthening backend architecture, authentication systems, database design, and Python-based automation. I actively practice debugging, API structuring, and performance optimization through project development.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Skills
